import { MAX_COUNT } from '../constants';

export function getComputedNudgesCount(count: number) {
  return count > MAX_COUNT ? MAX_COUNT : count;
}
